module.exports = __webpack_public_path__ + "img/pop-income02.4393357b.jpg";